import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'

import catalogPageCommon from '@/shared/stores/catalogPageCommon'
import optionProducts from '@/shared/stores/optionProducts'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  mixMatchPhotoSelectionModuleContent: window.pageData.catalogMix.mixMatchPhotoSelectionModuleContent,
  mixMatchSelections: [],
  showMixMatchValidation: false
}

const mutations = {
  initMixMatchSelections: (state, optionProducts) => {
    let result = []

    optionProducts.forEach(op => {
      let optionProductObj = {
        catalogPackageOptionProductId: op.CatalogPackageOptionProductID,
        quantity: op.Qty,
        frames: []
      }

      Object.seal(optionProductObj.quantity)
      result.push(optionProductObj)
    })

    state.mixMatchSelections = result
  },
  updateMixMatchSelection: (state, data) => {
    // find the index of the option product being updated
    const frameSelectionProductIndex = _.findIndex(state.mixMatchSelections, mms => {
      return mms.catalogPackageOptionProductId === data.catalogPackageOptionProductId
    })

    // get the existing slot entry record if it exists
    const existingSlotEntry = state.mixMatchSelections[frameSelectionProductIndex].frames[data.slotNumber]

    if (existingSlotEntry === undefined) { // if there's not already an entry in this slot
      // create a new entry for the frame
      state.mixMatchSelections[frameSelectionProductIndex].frames.push({
        frameId: data.frameId,
        quantity: data.quantity
      })
    } else {
      // update the slot entry with new data
      Vue.set(state.mixMatchSelections[frameSelectionProductIndex].frames, data.slotNumber, {
        frameId: data.frameId,
        quantity: data.quantity
      })
    }
  },
  removeMixMatchSelection: (state, data) => {
    const frameSelectionProductIndex = _.findIndex(state.mixMatchSelections, mms => {
      return mms.catalogPackageOptionProductId === data.catalogPackageOptionProductId
    })

    state.mixMatchSelections[frameSelectionProductIndex].frames.splice(data.slotNumber, 1)
  },
  updateMixMatchSelectionQuantity: (state, data) => {
    // find the index of the option product being updated
    const frameSelectionProductIndex = _.findIndex(state.mixMatchSelections, mms => {
      return mms.catalogPackageOptionProductId === data.catalogPackageOptionProductId
    })

    // get the existing slot entry record if it exists
    const existingSlotEntry = state.mixMatchSelections[frameSelectionProductIndex].frames[data.slotNumber]

    if (existingSlotEntry === undefined) {
      throw Error(`Could not find slot ${data.slotNumber} for product ${data.catalogPackageOptionProductId}`)
    } else {
      state.mixMatchSelections[frameSelectionProductIndex].frames[data.slotNumber].quantity = data.quantity
    }
  },
  toggleMixMatchValidationVisiblity: (state, isVisible) => {
    state.showMixMatchValidation = isVisible
  },
  toggleAlwaysShowRetouchingModal: (state, value) => {
    window.localStorage.setItem('alwaysShowRetouchingModal', value.toString())
    state.alwaysShowRetouchingModal = value
  }
}

const getters = {
  mixMatchSelectionsAreValid: state => {
    let result = true

    state.mixMatchSelections.forEach(mms => {
      const sumFramesSelected = mms.frames.reduce((sum, framesObj) => sum + framesObj.quantity, 0)

      if (sumFramesSelected < mms.quantity) {
        result = false
      }
    })

    return result
  },
  getRemainingEmptyFramesByProduct: state => catalogPackageOptionProductId => {
    const productGroup = _.find(state.mixMatchSelections, mms => {
      return mms.catalogPackageOptionProductId === catalogPackageOptionProductId
    })

    const sumFramesSelected = productGroup.frames.reduce((sum, framesObj) => sum + framesObj.quantity, 0)

    return productGroup.quantity - sumFramesSelected
  },
  getSelectedFramesByProduct: state => catalogPackageOptionProductId => {
    const productGroup = _.find(state.mixMatchSelections, mms => {
      return mms.catalogPackageOptionProductId === catalogPackageOptionProductId
    })

    return productGroup.frames
  }
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    catalogPageCommon,
    optionProducts
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./WebResources/vue/default/catalog-mix/store.js